import { AuthService } from "../login/AuthService";

export default class Http {

    constructor(private baseUrl: string,
                private authService: AuthService,
                private authFailureHandler: () => void) {
    }

    get(url: string) {
        const headers = new Headers();
        headers.set("x-access-token", this.authService.getAuthCredentials().token);

        const request = new Request(this.baseUrl + url, {
            method: 'GET',
            headers: headers
        });

        return fetch(request)
            .then(response => this.restrictedMatcher(response))
            .then(response => {
                if (response.status === 404) {
                    throw Error('404');
                }
                return response;
            })
            .then(response => response.json());
    }

    post(url: string, data: any = []) {
        const options: any = {
            method: 'POST',
            headers: { "x-access-token": this.authService.getAuthCredentials().token,
                       "Content-type": "application/json"},
            body: JSON.stringify(data)
        };

        return fetch(this.baseUrl + url, options)
            .then(response => this.restrictedMatcher(response))
            .then(response => response.json());
    }

    delete(url: string) {
        let options: any = {
            method: 'DELETE',
            headers: { "x-access-token": this.authService.getAuthCredentials().token },
        };

        return fetch(this.baseUrl + url, options)
            .then(response => this.restrictedMatcher(response));
    }

    restrictedMatcher(response) {
        if (response.status === 401) {
            this.authFailureHandler();
            throw new Error('Unauthorized: ' + 401);
        }

        return response;
    }


}
